import { IOperationResult } from "@Totum/QuestionnaireBuilder/Application/types";
import { createOperationResult } from "@Totum/QuestionnaireBuilder/Application/utils";
import {
    useDeleteQuestionnaireMutation,
    usePublishQuestionnaireMutation,
} from "@Totum/QuestionnaireBuilder/State/mutations";
import { useQuestionnairesQuery } from "@Totum/QuestionnaireBuilder/State/queries";

/**
 * Orchestrates the operations for the `Header` component.
 */
const useHeaderOperations = () => {
    // ** Hooks ** //
    const { data: questionnaireMinimalList, ...otherQuestionnairesQueryProps } = useQuestionnairesQuery();
    const publishQuestionnaireMutation = usePublishQuestionnaireMutation();
    const deleteQuestionnaireMutation = useDeleteQuestionnaireMutation();

    // ** Constants & Variables ** //
    const questionnaires = questionnaireMinimalList?.isSuccess ? questionnaireMinimalList.value.questionnaires : [];

    // ** Functions ** //

    /**
     * Delete the questionnaire
     */
    const deleteQuestionnaire = async (questionnaireId: string): Promise<IOperationResult> => {
        const mutationResult = await deleteQuestionnaireMutation.mutateAsync(questionnaireId);
        return createOperationResult(mutationResult.isSuccess);
    };

    /**
     * Publish the questionnaire
     */
    const publishQuestionnaire = async (questionnaireId: string): Promise<IOperationResult> => {
        const mutationResult = await publishQuestionnaireMutation.mutateAsync(questionnaireId);
        return createOperationResult(mutationResult.isSuccess);
    };

    // ** Exports ** //

    return {
        // data
        questionnaires,

        // methods
        deleteQuestionnaire,
        publishQuestionnaire,

        // state
        isFetchingQuestionnaires: otherQuestionnairesQueryProps.isFetching,
        isPublishing: publishQuestionnaireMutation.isLoading,
        isDeleting: deleteQuestionnaireMutation.isLoading,
    };
};

export default useHeaderOperations;
